import { Icon } from "@iconify/react";
import Dashboard from "./Dashboard";
import Configuration from "./Configuration";
import Settings from "./Settings";
import { useAppInfo } from "../../context/app";
import IntegrationDashboard from "./IntegrationDashboard";
import GetStarted from "./GetStarted";
import Support from "./Support";
import { SocketProvider } from "../../context/socket";
const useRoutes = () => {
  const [app] = useAppInfo();
  const routes = [
    {
      icon: <Icon icon="flowbite:users-group-outline" className="menu-icon" />,
      title: "Dashboard",
      key: "dashboard",
      route: "/dashboard",
      component: app?.featuresInclude?.includes("Conversation Providers") ? (
        <Dashboard />
      ) : (
        <IntegrationDashboard />
      ),
    },
    {
      icon: <Icon icon="flowbite:users-group-outline" className="menu-icon" />,
      title: "Configuration",
      key: "configuration",
      route: "/configuration",
      component: <Configuration />,
    },
    {
      icon: <Icon icon="flowbite:settings-adjust-outline" className="menu-icon" />,
      title: "Settings",
      key: "settings",
      route: "/settings",
      component: <Settings />,
    },
    {
      icon: <Icon icon="flowbite:users-group-outline" className="menu-icon" />,
      title: "Get Started",
      key: "get_started",
      route: "/get_started",
      component: <GetStarted />,
    },
    {
      icon: <Icon icon="mdi:headset" className="menu-icon" />,
      title: "Support",
      key: "support",
      route: "/support",
      component: (
        <SocketProvider>
          <Support />
        </SocketProvider>
      ),
    },
  ];
  return routes;
};

export default useRoutes;
